import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const IconTip = ({tip, children}) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tip}</Tooltip>}>
        <span>{children}</span>
    </OverlayTrigger>
);

export default IconTip;
